import { useEffect, useState } from "react";
import API from "../../api/phx";
import Cookies from 'js-cookie';
import { getDomainConfig } from "../../config/config";
import { getLanguageCode } from "../../utils/getURLParams";
import Paypal from "./Paypal";
import { markOrderPaymentStatusFailed } from "../../utils/markPaymentAsFailed";
import { googleDataLayer } from "../Analytics/Universal/PageView/googleDataLayer";
import ExitPopUp from '../../utils/exitPopUp';

const PaypalV3 = ({ isFormValid, submittingForm, styles, amountToPay, showFormFunc, isCro1381, shouldLoadPaypal, setOrder, setOrderCreationStatus, setOpenModal, setShowExternalPaymentError }) => {

    const domainConfig = getDomainConfig();

    const CONTEXT_API = 'payments/checkoutdotcom/paypal-context';
    const PAYMENT_API = 'payments/checkoutdotcom/paypalV3';

    const [paymentFailed, setPaymentFailed] = useState(false);

    useEffect(() => {
        // Function to update form validity
        function updateFormValidity(valid) {
            // Trigger custom event
            var event = new CustomEvent('formValidityChanged', { detail: { isValid: valid } });
            document.dispatchEvent(event);
        }

        // Performing event update when isFormValid function from useForm hook will change to true.
        updateFormValidity(isFormValid);

    }, [isFormValid])

    useEffect(() => {

      if(window.paypal && shouldLoadPaypal) {

        document.getElementById("paypalButton").innerHTML = "";

            window.paypal
              .Buttons({

                onInit(data, actions) {

                      // Call onInit initially and disabling Paypal button.
                      if (isFormValid) {
                          actions.enable();
                      } else {
                          actions.disable();
                      }

                      // Function triggered when form validation changed.
                      function handleFormValidityChange(event) {
                          if (event.detail.isValid) {
                              actions.enable();
                          } else {
                              actions.disable();
                          }
                      }
                      // Event listener to listen for form validity changes. As a default form valid state will be as false, if everything will be filed up correctly,
                      // Paypal button will be enabled and ready to perform popup.
                      document.addEventListener('formValidityChanged', handleFormValidityChange);
                },

                onClick () {
                  // Submitting form on click to tiger useForm form validation check, if there are any errors/empty fields, form won't be submitted and
                  // Paypal popup won't come up.
                  submittingForm();
                  setPaymentFailed(false);
                  googleDataLayer.createUserClickInputEvent('PayPalButtonClick');
                  // clear failed payment error
                  setShowExternalPaymentError(false)
                },

                async createOrder() {

                  return new Promise((resolve, reject) => {
                    var orderDetails = undefined;

                    var getContextInterval = setInterval(() => {
                      orderDetails = PaypalContext.GetOrderDetails();
                      if (orderDetails !== undefined) {
                          clearInterval(getContextInterval);

                          const amountToFixed = (amountToPay * 100).toFixed();
                          const orderDataRequest = {
                            amount: amountToFixed,
                            currency: orderDetails.currency,
                            orderId: orderDetails.orderId,
                            items: [
                                {
                                    name: "Total",
                                    quantity: 1,
                                    unit_price: amountToFixed,
                                    total_amount: amountToFixed
                                }
                            ]
                          }

                        try {
                          API.post(CONTEXT_API, orderDataRequest,{
                            withCredentials: true
                          }).then(function (response) {
                            if (response.data.order_id) {
                              PaypalContext.SetPaymentContext(response.data.payment_context_id);
                            } else {
                                markOrderPaymentStatusFailed(orderDetails.orderId,true,'PayPal').then(() => {
                                  setShowExternalPaymentError(true);
                                  showFormFunc();
                                  setOrder({});
                                  PaypalContext.SetOrderDetails(undefined);
                                });
                            }
                            resolve(response.data.order_id);
                          });

                        } catch (error) {
                            markOrderPaymentStatusFailed(orderDetails.orderId,true,'PayPal').then(() => {
                              setShowExternalPaymentError(true);
                              showFormFunc();
                              setOrder({});
                              PaypalContext.SetOrderDetails(undefined);
                            });
                        }
                      }
                    }, 1000);
                  });
                },

                // This will be called when transaction was approved and successful.
                // We need to make GET call to D6 paypal API and retrieve information about the order from payments-context, based on that redirect to order complete page.
                async onApprove(data, actions) {
                  setOrderCreationStatus("finalizing");

                  try {
                    const paymentContext = {
                      payment_context_id: PaypalContext.GetPaymentContext()
                    }
                    const response = await API.post(PAYMENT_API, paymentContext,{
                      withCredentials: true
                    })

                    const errorDetail = response.data?.details?.[0];

                    if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
                      return actions.restart();
                    } else {
                      const orderDetails = PaypalContext.GetOrderDetails();
                      const orderId = orderDetails.orderId;

                      if (response.data.approved && (response.data.status === "Captured")) {
                        API.delete("/cart").then(() => {
                          Cookies.set("orderDoComplete",true);
                          Cookies.set("risk",false);
                          Cookies.set("flagged",false);
                          Cookies.set("display",true)

                          ExitPopUp.Disable();
                          window.location.href = `${getLanguageCode(
                            domainConfig.brand,
                            true
                          )}/cart/checkout/complete/${orderDetails.orderId}`;
                        });
                      } else {
                        markOrderPaymentStatusFailed(orderId, false, 'PayPal').then(() => {
                          setPaymentFailed(true);
                          showFormFunc();
                          setOrder({});
                          PaypalContext.SetOrderDetails(undefined);
                        })
                      }
                    }
                  } catch (error) {
                    console.error(error);
                  }
                },
                async onCancel (data) {
                  const orderDetails = PaypalContext.GetOrderDetails();
                  markOrderPaymentStatusFailed(orderDetails.orderId,true,'PayPal').then(() => {
                    setShowExternalPaymentError(true);
                    setOpenModal(false);
                    showFormFunc();
                    setOrder({});
                    PaypalContext.SetOrderDetails(undefined);
                  });
                },

                async onError(err) {
                  const orderDetails = PaypalContext.GetOrderDetails();
                  markOrderPaymentStatusFailed(orderDetails.orderId,true,'PayPal').then(() => {
                    setShowExternalPaymentError(true);
                    setOpenModal(false);
                    showFormFunc();
                    setOrder({});
                    PaypalContext.SetOrderDetails(undefined);
                  });
                  console.error('error type',err)
                }
              })
              .render("#paypalButton");
        }
    }, [amountToPay,isFormValid, shouldLoadPaypal])

    return (
      <Paypal styles={styles} amountToPay={amountToPay} paymentFailed={paymentFailed} isCro1381={isCro1381}/>
    );
}
export class PaypalContext {
  static paymentContextId;
  static orderDetails;

  static SetPaymentContext(contextId){
    this.paymentContextId= contextId;
  }
  static GetPaymentContext(){
    return this.paymentContextId;
  }
  static SetOrderDetails(orderDetails) {
    this.orderDetails = orderDetails;
  }
  static GetOrderDetails(){
    return this.orderDetails;
  }
}
export default PaypalV3;